!((document, Drupal, $) => {
  'use strict';

  Drupal.behaviors.fedeInEffetc = {
    attach: function() {
      function handleReveals(reveals) {
        // On scroll fade in effect
        if (reveals !== null) {
          ['load', 'scroll'].forEach(function(evt) {
            window.addEventListener(evt, function() {
              for (let i = 0; i < reveals.length; i++) {
                let windowHeight = window.innerHeight;
                let elementTop = reveals[i].getBoundingClientRect().top;
                let elementVisible = 150;

                if (elementTop < windowHeight - elementVisible) {
                  reveals[i].classList.add('reveal');
                }
              }
            }, {passive: true});
          });
        }
      }

      $(window).ready(function() {
        let reveals = null;

        if ($('.two-column-benefits .card').length > 0) {
          reveals = $('.two-column-benefits .card');
          handleReveals(reveals);
        }

        if ($('.two-column-benefits .content .list-item').length > 0) {
          reveals = $('.two-column-benefits .content .list-item');
          handleReveals(reveals);
        }

        if ($('.two-column-benefits .arrow-button').length > 0) {
          reveals = $('.two-column-benefits .arrow-button');
          handleReveals(reveals);
        }
      });
    }
  };
})(document, Drupal, jQuery);
